import React from 'react';
import { G as Glimmer } from './Glimmer-C-gTChiy.js';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { u as useActiveLayout } from './useActiveLayout-Cit0_Js3.js';

var styles = {"wrapper":"_8cMzUF8XEwY-","loadingItem":"Rh--6fVpkm4-","glimmer":"NFaWWvmxtkw-"};

const LOADING_STATE_LIMIT_ITEMS = 10;
const DATALIST_LOADINGSTATE_ROW_TEST_ID = "ATL-DataList-LoadingState-Row";
function DataListLoadingState() {
    const { headers } = useDataListContext();
    const { layout, activeBreakpoint } = useActiveLayout();
    if (!layout)
        return null;
    const glimmerSize = activeBreakpoint === "xs" ? "small" : "large";
    const glimmersFromHeader = Object.keys(headers).reduce((data, key) => (Object.assign(Object.assign({}, data), { [key]: (React.createElement("div", { className: styles.glimmer },
            React.createElement(Glimmer, { size: glimmerSize }))) })), {});
    const loadingData = new Array(LOADING_STATE_LIMIT_ITEMS).fill(glimmersFromHeader);
    return (React.createElement("div", { className: styles.wrapper }, loadingData.map((child, i) => (React.createElement("div", { key: i, className: styles.loadingItem, "data-testid": DATALIST_LOADINGSTATE_ROW_TEST_ID }, layout(child))))));
}

export { DATALIST_LOADINGSTATE_ROW_TEST_ID as D, LOADING_STATE_LIMIT_ITEMS as L, DataListLoadingState as a };
